var React = require('react');

function BusinessAnalyticInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.334 5.91667H20.6673V3.08333L17.834 0.25H12.1673L9.33398 3.08333V5.91667H3.66732C2.10898 5.91667 0.833984 7.19167 0.833984 8.75V15.8333C0.833984 16.8958 1.40065 17.7883 2.25065 18.2842V22.9167C2.25065 24.4892 3.51148 25.75 5.08398 25.75H24.9173C26.4898 25.75 27.7507 24.4892 27.7507 22.9167V18.27C28.5865 17.7742 29.1673 16.8675 29.1673 15.8333V8.75C29.1673 7.19167 27.8923 5.91667 26.334 5.91667ZM12.1673 3.08333H17.834V5.91667H12.1673V3.08333ZM3.66732 8.75H26.334V15.8333H19.2507V11.5833H10.7507V15.8333H3.66732V8.75ZM16.4173 17.25H13.584V14.4167H16.4173V17.25ZM24.9173 22.9167H5.08398V18.6667H10.7507V20.0833H19.2507V18.6667H24.9173V22.9167Z","fill":"black"}));
}

BusinessAnalyticInline.defaultProps = {"width":"30","height":"26","viewBox":"0 0 30 26","fill":"none"};

module.exports = BusinessAnalyticInline;

BusinessAnalyticInline.default = BusinessAnalyticInline;
